import { DatePipe, NgClass } from '@angular/common';
import {
  booleanAttribute, ChangeDetectionStrategy, Component, computed, HostBinding, inject, input,
} from '@angular/core';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IconModule } from '@hglobal/common';
import { environment } from '@pt/environment';
import { Transaction } from '@pt/models';

import { CoinComponent } from '../../../coin/coin.component';

@Component({
  selector: 'pt-transaction, [ptTransaction]',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, IconModule, DatePipe, NgClass, CoinComponent],
})
export class TransactionComponent {
  transaction = input.required<Transaction>();
  widget = input(false, { transform: booleanAttribute });

  @HostBinding('class.pt-transaction_widget')
  private get _widget() {
    return this.widget();
  }

  readonly #translateService = inject(TranslateService);

  readonly name = computed(() => {
    const { metric, user } = this.transaction();
    return this.#translateService.instant(
      `transaction.metric.${metric}`,
      { userName: user?.fullName || 'User', appName: environment.appNameForTransaction },
    );
  });
}
